export default {
  template: require('./asset-upload-conflict-modal.component.html').default,
  bindings: {
    conflicts: '<',
    showConflictModal: '<',
    confirmReplace: '&',
    cancelUpload: '&',
    getOrientationText: '&'
  }
}
